// @ts-expect-error Untyped import
import DateRangeLabel from 'reporting-ui-components/components/shared/DateRangeLabel';
import { ReportDateRangeTooltipContent, shouldReportShowInlineDateRangeLabel } from './reportDateRangeContent';
import { ReportFrequencyTooltipContent, shouldReportShowInlineFrequencyLabel } from './reportFrequencyContent';
import I18n from 'I18n';
import { getUseFiscalYear } from 'reporting-data/lib/fiscalYearUtils';
// @ts-expect-error Untyped import
import { ConditionalLabel, Label } from '../Label';
import { StandardInlineLabel } from '../labelComponents/StandardInlineLabel';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDateRangeValue = config => config.getIn(['filters', 'dateRange', 'value']);
const getReportFrequency = config => config.get('frequency');
const getInlineLabelBadgeText = config => {
  const useFiscalYear = getUseFiscalYear(config);
  const isReportValidForDateRangeLabel = shouldReportShowInlineDateRangeLabel(config);
  const isReportValidForFrequencyLabel = shouldReportShowInlineFrequencyLabel(config);
  const reportFrequency = isReportValidForFrequencyLabel && I18n.text(`settingLabels.frequency.valueLabels.${getReportFrequency(config)}`);
  let inlineLabelBadgeText = /*#__PURE__*/_jsx(_Fragment, {});
  const dateRangeLabel = /*#__PURE__*/_jsx(DateRangeLabel, {
    dateRange: getDateRangeValue(config),
    useFiscalYear: useFiscalYear
  });
  if (isReportValidForDateRangeLabel && isReportValidForFrequencyLabel) {
    inlineLabelBadgeText = /*#__PURE__*/_jsxs("span", {
      children: [dateRangeLabel, " | ", reportFrequency]
    });
  } else if (isReportValidForDateRangeLabel) {
    inlineLabelBadgeText = dateRangeLabel;
  } else if (isReportValidForFrequencyLabel) {
    inlineLabelBadgeText = /*#__PURE__*/_jsx("span", {
      children: reportFrequency
    });
  }
  return inlineLabelBadgeText;
};
export const condition = ({
  config
}) => config && (shouldReportShowInlineDateRangeLabel(config) || shouldReportShowInlineFrequencyLabel(config));
export const render = Label(({
  config
}) => {
  const isReportValidForDateRangeLabel = shouldReportShowInlineDateRangeLabel(config);
  const isReportValidForFrequencyLabel = shouldReportShowInlineFrequencyLabel(config);
  const inlineLabelBadgeText = getInlineLabelBadgeText(config);
  return /*#__PURE__*/_jsx(StandardInlineLabel, {
    tooltipProps: {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [isReportValidForDateRangeLabel && /*#__PURE__*/_jsx(ReportDateRangeTooltipContent, {
          config: config
        }), isReportValidForFrequencyLabel && /*#__PURE__*/_jsx(ReportFrequencyTooltipContent, {
          config: config
        })]
      })
    },
    inlineLabelBadgeText: inlineLabelBadgeText,
    dataTestId: 'inline-date-range-and-frequency-label'
  });
});
export const renderWithCondition = ConditionalLabel(condition, render);